import { i18n } from "../../../language";
import store from "../../../store/";

let isDarkMode = () => store.state.user.darkMode;
export default function getData(data) {
    return {
        grid: {
            right: "30%",
        },
        /*title: {
            text: i18n.tc('message.statsByTime')
        },*/
        legend: {
            show: true,
            orient: "vertical",
            left: 0,
        },
        toolbox: {
            feature: {
                saveAsImage: {
                    pixelRatio: 2,
                    title: "Download",
                },
            },
        },
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },
        },
        series: [
            {
                type: "pie",
                data,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                    },
                },
            },
        ],
    };
}
